var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('el-steps',{attrs:{"active":_vm.$route.meta.active,"finish-status":"success","simple":""}},_vm._l((_vm.stepList),function(item){return _c('el-step',{key:item,attrs:{"title":item}})}),1)],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }